// Общие помощники. Без зависимостей.

/**
 * Таймкод комментария в 7cut — строка: "12.5" или диапазон "12.5 - 20.1" (секунды).
 * Возвращает { start, end } в секундах или null.
 */
export function parseTimecode(tc) {
  if (tc == null || tc === "") return null;
  if (typeof tc === "number") return isFinite(tc) ? { start: tc, end: null } : null;
  const s = String(tc);
  if (s.includes("-")) {
    const [a, b] = s.split("-").map((x) => parseFloat(x));
    if (!isFinite(a)) return null;
    return { start: a, end: isFinite(b) && b > a ? b : null };
  }
  const v = parseFloat(s);
  return isFinite(v) ? { start: v, end: null } : null;
}

/** 65.4 -> "1:05", 3725 -> "1:02:05" */
export function formatTime(seconds) {
  const t = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;
  const mm = h ? String(m).padStart(2, "0") : String(m);
  return `${h ? h + ":" : ""}${mm}:${String(s).padStart(2, "0")}`;
}

export const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

/** Имя автора комментария: "Имя Фамилия", иначе email. */
export function authorName(author) {
  if (!author) return "";
  const full = [author.firstName, author.lastName].filter(Boolean).join(" ").trim();
  return full || author.email || "";
}

/** Инициалы для аватара-заглушки. */
export function initials(author) {
  const name = authorName(author);
  if (!name) return "?";
  const parts = name.replace(/@.*$/, "").split(/[\s._-]+/).filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0].toUpperCase()).join("");
}

/** Стабильный цвет по строке — для аватаров без картинки. */
export function colorFromString(str, palette = AVATAR_PALETTE) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}

const AVATAR_PALETTE = ["#9a6aff", "#427fff", "#4fd07e", "#f58b3a", "#24cee0", "#f73daa", "#aeda46", "#37aef5"];

/** Разбивает текст комментария на куски: обычный текст и @упоминания. */
export function splitMentions(content) {
  return String(content || "")
    .split(/(@[^\s]+)/g)
    .filter((p) => p !== "")
    .map((p) => ({ text: p, mention: p.startsWith("@") }));
}
